import { Text, Flex } from '@chakra-ui/react';
import Link from 'next/link';

const RelatedNewsItem = ({ news }) => {
  return (
    <Flex
      borderBottomWidth={'2px'}
      borderColor={'grey'}
      _last={{ borderWidth: '0' }}
    >
      <Link href={`/news/${news?.slug}`} alt={news?.title}>
        <Flex {...{ w: 'full', h: 'full', overflow: 'hidden', py: '12px' }}>
          <Text
            fontSize={'14px'}
            fontWeight={'700'}
            letterSpacing={'0.28px'}
            lineHeight={'1.2'}
            noOfLines={2}
          >
            {news?.title}
          </Text>
        </Flex>
      </Link>
    </Flex>
  );
};

export default RelatedNewsItem;
